import { Box, Button, Grid, makeStyles, TextField } from "@material-ui/core"
import { AssociatedSmsChannel } from "@root/store/types"
import React from "react"

export interface Props {
  onAssociate: (email: AssociatedSmsChannel) => void
}

const useStyles = makeStyles({
  button: {
    alignSelf: "center",
  },
})

const AssociatedSms: React.FC<Props> = ({ onAssociate }) => {
  const [msisdn, setMsisdn] = React.useState("")
  const [senderId, setSenderId] = React.useState("")
  const classes = useStyles()

  return (
    <Box
      component="form"
      data-qa-selector="associated-sms-form"
      onSubmit={(ev) => {
        ev.preventDefault()
        onAssociate({ platform: "sms", msisdn, senderId })
        setMsisdn("")
      }}
    >
      <Grid container spacing={2}>
        <Grid item sm={5} xs={12}>
          <TextField
            type="tel"
            data-qa-selector="sender-id-input"
            fullWidth
            required
            id="sender-id-id"
            label="Sender ID"
            value={senderId}
            onChange={(ev) => setSenderId(ev.target.value)}
          />
        </Grid>
        <Grid item sm={5} xs={12}>
          <TextField
            type="tel"
            data-qa-selector="msisdn-input"
            fullWidth
            required
            id="msisdn-id"
            label="MSISDN"
            value={msisdn}
            onChange={(ev) => setMsisdn(ev.target.value)}
          />
        </Grid>
        <Grid item sm={2} xs={12} className={classes.button}>
          <Button
            fullWidth
            data-qa-selector="submit"
            type="submit"
            variant="contained"
            disabled={!msisdn || !senderId}
          >
            Register
          </Button>
        </Grid>
      </Grid>
    </Box>
  )
}

export default AssociatedSms
